module.exports = __webpack_public_path__ + "af4782fa0e9dc029f9e0b78b46333433.png";